import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsScrollerUsersWithdrawalsByCurrency = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/scrollers/withdrawals/by-currency`, {params});
};